/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var Tag = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ size: "25px" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#3d3d36", transform: "translate(2 2)" },
            React.createElement("path", { d: "m5.80645161 0 9.19354839 9.19354839-5.80645161 5.80645161-9.19354839-9.19354839v-5.80645161z" }),
            React.createElement("circle", { cx: "3.870968", cy: "3.870968", r: "1.451613" }))));
};
export default Tag;
